import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const Copy = createComponent('p', {
  className: 'text-text-default t-body-sm'
});

export const Form = createComponent('form', {
  className: 'grid w-full grid-cols-[1fr_89px] gap-md align-top'
});

export const Heading = createComponent('h2', {
  className: 'text-text-strong t-heading-md sm:t-heading-xl'
});

export const LowerContentWrapper = createComponent('div', {
  className: 'flex flex-col gap-xl'
});

export const OptionTitle = createComponent('h3', {
  className: 'flex items-center gap-sm text-text-strong t-heading-sm'
});

export const OptionWrapper = createComponent('div', {
  className: cx(
    'flex flex-auto flex-col gap-md rounded-md border border-border-subtle p-xl'
  )
});
